import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage, useIntl } from "react-intl";
import { useTheme } from "./ThemeContext";
export const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();
    const intl = useIntl();
    const label = getLabel(intl);
    return (_jsxs("label", { className: "toggle flex-between", htmlFor: "color-mode", children: [_jsx("span", { className: "text-small", children: _jsx(FormattedMessage, { id: "themeToggle.color", defaultMessage: "Color theme", description: "color mode toggle" }) }), _jsx("input", { onChange: toggleTheme, className: "toggle-checkbox", type: "checkbox", checked: theme === "dark", id: "color-mode", "aria-label": label }), _jsx("div", { className: "toggle-switch" })] }));
    function getLabel(intl) {
        if (theme === "dark") {
            return intl.formatMessage({
                defaultMessage: "Change to light mode",
                description: "Color toggle aria label to light",
                id: "themeToggle.colorLabel",
            });
        }
        else {
            return intl.formatMessage({
                defaultMessage: "Change to dark mode",
                description: "Color toggle aria label to dark",
                id: "themeToggle.label",
            });
        }
    }
};
